import { apiCall } from '@/util/apiCall'
import type { TranslationKey } from '@/util/translate/types/keys'
import { languagesLoad } from '../languages'
import { makeLoader } from './load'

export const loadLanguage = makeLoader<{ id: string }>({
	id: ({ id }) => `language:${id}`,
	loader: async (api, { id }) => {
		void api
		if (!id) throw new Error('No language given')

		const translations = await apiCall<Record<string, TranslationKey>>(
			'/valkyrie/translations/:id',
			{
				params: { id },
				signal: api.signal,
			},
		)

		return languagesLoad({
			[id]: { id, keys: translations, timezone: 'Europe/Paris' },
		})
	},
	check: (state, { id }) => id in state.languages.languageKeys,
})
